import type { AriaRole } from 'react';
import { IconComponents } from './IconComponents';
import { reportMissingIconNameToSentry } from './iconHelpers';

export type AnyIcon = keyof typeof IconComponents;

const DEFAULT_STROKE_WIDTH = 1.5;
export interface IconProps {
  id?: string;
  ariaLabel?: string;
  className?: string;
  fill?: string;
  name: string;
  role?: AriaRole;
  strokeWidth?: number;
  style?: React.CSSProperties;
  testId?: string;
  title?: string;
}

export const Icon = ({
  id,
  ariaLabel,
  className,
  fill = 'none',
  name,
  role = 'presentation',
  strokeWidth = DEFAULT_STROKE_WIDTH,
  style,
  testId,
  title,
}: IconProps) => {
  const IconComponent = IconComponents[name as AnyIcon];
  const iconProps = {
    id,
    'aria-label': ariaLabel,
    className,
    'data-testid': testId,
    fill,
    role,
    strokeWidth,
    style,
    title,
  };

  if (!IconComponent) {
    reportMissingIconNameToSentry(name);
    return null;
  }

  return <IconComponent {...iconProps} />;
};
